import Autocomplete from "@/components/Autocomplete";
import Chip, { ChipSet } from "@/components/Chip/Chip";
import ListItem from "@/components/ListItem/ListItem";
import type { Ref } from "react";
import { teamVisibilitySupportingText } from "./privateTaskCopy";
import type { TeamVisibilityOption } from "./teamVisibilityOptions";

type TeamVisibilityFieldProps = {
  selectedTeamTags: string[];
  teamSearchTerm: string;
  onTeamSearchChange: (value: string) => void;
  availableDepartmentOptions: TeamVisibilityOption[];
  onSelect: (option: TeamVisibilityOption) => void;
  onRemove: (department: string) => void;
  disabled?: boolean;
  "data-testid"?: string;
  autocompleteContainerRef?: Ref<HTMLDivElement>;
};

export default function TeamVisibilityField({
  selectedTeamTags,
  teamSearchTerm,
  onTeamSearchChange,
  availableDepartmentOptions,
  onSelect,
  onRemove,
  disabled = false,
  "data-testid": dataTestId,
  autocompleteContainerRef
}: TeamVisibilityFieldProps) {
  return (
    <div className="space-y-3">
      <div ref={autocompleteContainerRef}>
        <Autocomplete<TeamVisibilityOption>
          label="Team Visibility"
          variant="searchableDropdown"
          supportingText={teamVisibilitySupportingText()}
          query={teamSearchTerm}
          data={availableDepartmentOptions}
          onChangeText={onTeamSearchChange}
          reset={() => onTeamSearchChange("")}
          onSelect={onSelect}
          renderItem={(option) => <ListItem compact headline={option.label} />}
          data-testid={dataTestId}
          constrainMenuWidth
          menuClassName="max-h-[300px]"
          disabled={disabled}
        />
      </div>
      {selectedTeamTags.length > 0 && (
        <ChipSet>
          {selectedTeamTags.map((tag) => (
            <Chip
              key={tag}
              label={tag}
              removeOnly
              onRemove={(e) => {
                e?.preventDefault?.();
                onRemove(tag);
              }}
            />
          ))}
        </ChipSet>
      )}
    </div>
  );
}
